import { fetchUtils, GET_ONE } from "react-admin";

const initProjectTeamsResultsProvider = (
  apiUrl,
  httpClient = fetchUtils.fetchJson,
  defaultCrudHandler,
  convertDataRequestToHTTP
) => {
  return (type, resource, params) => {
    switch (type) {
      case GET_ONE:
        return httpClient(`${apiUrl}/teams/${params.id}/overall`).then(
          (response) => ({
            data: { id: params.id, ...response.json },
          })
        );
      default:
        return defaultCrudHandler(type, resource, params);
    }
  };
};

export default initProjectTeamsResultsProvider;
